function setSegmentIdentity(guid) {
  // segment identify call
  window.analytics.identify(guid, {});
}

export default setSegmentIdentity;
